import { keyBy, memoize } from 'lodash';
import { FieldOptionBase } from 'api/tasks';
import { Comparator } from 'components/atoms/grid';
import { Field } from 'stores/fields';
import { getBaseComparator } from 'utils/comparators/base-comparator';
import { byPriority } from 'utils/comparators/by-priority';
import { sortByText } from 'utils/sort-by-text';
import { MultiSelectField, SingleSelectField } from '../fields';

type Nullable<T> = T | null;
type OptionsField = SingleSelectField | MultiSelectField;

export const getComparator = <T = any>(
  field: Pick<Field, 'type' | 'metaData' | 'fieldName'>,
  projectId?: number,
): Comparator<T> | undefined => {
  const options =
    (field as OptionsField).metaData?.options ?? ([] as FieldOptionBase[]);
  const getLabel = memoize(
    (value: Nullable<number>) =>
      value == null ? null : options.find((o) => o.value === value)?.label,
    (value) => value?.toString() ?? 'null',
  );

  if (field.fieldName.toLowerCase() === 'priority') {
    return (a: T, b: T) => {
      const a_value = getLabel(a as any) ?? 'null';
      const b_value = getLabel(b as any) ?? 'null';

      return byPriority({ label: a_value }, { label: b_value });
    };
  }
  if (field.fieldName === 'projectPhaseId') {
    const phaseOptionsLookup = keyBy(options, 'value');

    return (a: T, b: T) => {
      const val1 = typeof a === 'number' ? phaseOptionsLookup[a]?.label : a;
      const val2 = typeof b === 'number' ? phaseOptionsLookup[b]?.label : b;
      const checkA = val1 !== '-' ? (val1 as string) : '';
      const checkB = val2 !== '-' ? (val2 as string) : '';

      return sortByText(checkA, checkB);
    };
  }

  return getBaseComparator(field, projectId);
};
